export default "/images/vn.svg?bcf8a28ccc0822ea4e6f3fa73ec7547f";